<template>
    <div>
        <input type="file" @change="changeFile" ref="uploadFile" :multiple="false" :accept="accept.join(',')" v-show="false"/>
    </div>
</template>

<script>
    import axios from 'axios'
    import { getAliFileUploadUrl } from '@/utils/baseUrl.js'
    const OSS = require('ali-oss')
    export default {
        props: {
            accept: {
                type: Array,
                default: () =>  ['.pdf']
            },
            maxSize: { // 文件大小限制 单位mb
                type: Number,
                default: 5
            },
            uploadType: { // 上传方式 img/video/audio/other
                type: String,
                default: 'other'
            },
            showSuccessTip: { // 显示成功上传提示
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                isUploading: false // 上传中
            }
        },
        watch:{
            isUploading(nval){
                this.$emit('isNowUploading',nval)
            }
        },
        computed: {
            requestUploadParams() {
                let params = getAliFileUploadUrl()
                let comParams = {
                    ...params,
                    ...params[this.uploadType]
                }
                return comParams
            },
        },
        methods: {
            // 选择文件
            uploadFile(){
                this.$refs.uploadFile.click()
            },
            // 已选择文件
            changeFile(e) {
                let file = e.target.files[0]
                console.log('file:',file)
                this.uploadToOss(file)
                e.target.value = ''
            },
            // 上传至oss
            async uploadToOss(file){
                if(file.size > this.maxSize * 1024 * 1024){
                    this.errMessage(`上传文件需小于${this.maxSize}mb`)
                    return
                }
                if(this.isUploading){
                    this.errMessage(`请稍候，上传中...`)
                    return
                }
                this.isUploading = true
                this.$emit('startUpload') // 开始上传
                try{
                    let suffix = file.name.slice(file.name.lastIndexOf('.'), file.name.length)
                    suffix = suffix.toLowerCase()
                    // 获取oss校验信息
                    let params =  await this.httprequest({ 
                        method: 'get',
                        url: '/v1/ali/token',
                        data: {}
                    })
                    console.log('params:',params)
                    const client = new OSS({
                        // yourRegion填写Bucket所在地域。以华东1（杭州）为例，yourRegion填写为oss-cn-hangzhou。
                        region: this.requestUploadParams.region,
                        // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
                        accessKeyId: params.AccessKeyId,
                        accessKeySecret: params.AccessKeySecret,
                        // 从STS服务获取的安全令牌（SecurityToken）。
                        stsToken: params.SecurityToken,
                        // 填写Bucket名称。
                        bucket: this.requestUploadParams.bucket,
                        refreshSTSToken: async () => {
                            let res =  await this.httprequest({
                                method: 'get',
                                url: '/v1/ali/token',
                                data: {}
                            })
                            return {
                                accessKeyId: res.AccessKeyId,
                                accessKeySecret: res.AccessKeySecret,
                                stsToken: res.SecurityToken
                            }
                        },
                        refreshSTSTokenInterval: 20 * 60 * 1000
                    })
                    const uploadPath =  this.requestUploadParams.projectFirst + this.requestUploadParams.projectSecond + params.date_dir + '/'+ this.randomString(20) + suffix
                    // 接口上传至oss
                    let uploadRes = await client.put(
                        uploadPath,
                        file
                    )
                    const url = this.requestUploadParams.zip?  this.requestUploadParams.domain  + '/' + uploadRes.name + this.requestUploadParams.zip + suffix.toLocaleLowerCase().replace(/./, '') : this.requestUploadParams.domain  + '/' + uploadRes.name
                    let obj = {
                        url: url,
                        origin_name: file.name,
                        suffix: suffix,
                        size: file.size
                    }
                    console.log('uploadSuccess-obj:',obj)
                    this.$emit('uploadSuccess',obj)
                    if(this.showSuccessTip){
                        this.errMessage('上传成功','success')
                    }
                    this.isUploading = false
                }catch(err){
                    this.$emit('uploadErr',err)
                    this.$message({
                        message: '上传失败，请重试',
                        type: 'error',
                        duration: 3000
                    })
                    console.error('上传失败-err:',err)
                    this.isUploading = false
                }
                
            },
            randomString(e) {
                e = e || 32;
                var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
                    a = t.length,
                    n = "";
                for (var i = 0; i < e; i++) {
                    n += t.charAt(Math.floor(Math.random() * a))
                }
                return n + Date.now()
            },
            httprequest() {
                const instance = axios.create({
                    baseURL: this.requestUploadParams.requestUrl,
                    defaults: {
                        headers: {}
                    }
                })
                return new Promise((resolve) => {
                    instance(arguments[0]).then(res => {
                        if(res.data.code === 200) {
                            resolve(res.data.data)
                        } else {
                            this.errMessage(res.data.msg,'error')
                        }
                    })
                })
            },
            errMessage(message, type="error", duration=3000) {
                this.$message({
                    type,
                    duration,
                    message
                })
            },
        }
    }
</script>